<style lang="less" scoped>
/deep/ .sz-card {
  padding: 12px;
  margin-bottom: 12px;
  .sz-card__header {
    padding: 12px 0;
    padding-top: 0;
  }
}
</style>

<template>
  <el-form ref="form" :model="model" :rules="rules" :disabled="disabled" label-position="top" size="mini">
    <slot></slot>
  </el-form>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive, provide, ref } from "vue";
export default defineComponent({
  props: {
    model: {
      type: Object,
      default: () => {
        return {};
      },
    },

    rules: {
      type: Object,
      default: () => {
        return {};
      },
    },

    filter: {
      type: Array as PropType<any[]>,
      default: (): any => [],
    },

    source: {
      type: Object as PropType<any>,
      default: (): any => {
        return {};
      },
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const form: any = ref({});
    provide("filter", props.filter);
    provide("source", props.source);

    const validateFn = () => {
      let result = false;
      form.value.validate((valid: boolean) => {
        result = valid;
      });
      return result;
    };

    return {
      form,
      validateFn,
    };
  },
  /****************************************************************
   *
   *
   *
   ***************************************************************/
});
</script>
